// extracted by mini-css-extract-plugin
module.exports = {"root":"Column_root__Dap1n"};